import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
} from '@angular/core';
import { ExpandedStatusService } from '../../services/expanded-status/expanded-status.service';

@Directive({
  selector: '[bsExpandedRow]',
  exportAs: 'expandedRow',
})
export class UiExpandedRowDirective<T> {
  expandedElement!: T | null;
  @Input() tableColumns!: string[];
  @Input() tableElement!: any;
  @Input() bsExpandedRow!: number;
  @Input() expandedElementViewMedia!: number;
  @HostBinding('style.cursor') cursor!: string;
  @HostBinding('class.expanded-row') get expandedRow() {
    if (!this.bsExpandedRow || window.innerWidth >= this.bsExpandedRow)
      return false;

    this.elementRef.nativeElement.style.cursor = 'pointer';

    const isActive =
      this.expandedStatusService.activedExapandedRow.find(
        (element) => element === this.tableElement
      ) ?? this.expandedElement === this.tableElement;

    return isActive;
  }
  @HostListener('click', ['$event']) onClick(event: Event): void {
    if (!this.bsExpandedRow || window.innerWidth >= this.bsExpandedRow) return;

    event.stopPropagation();

    event.stopImmediatePropagation();

    this.expandedElement =
      this.expandedElement === this.tableElement ? null : this.tableElement;

    const hasOpen = this.expandedStatusService.activedExapandedRow.find(
      (element) => element === this.tableElement
    );

    if (hasOpen) {
      this.expandedStatusService.activedExapandedRow =
        this.expandedStatusService.activedExapandedRow.filter(
          (element) => element !== this.tableElement
        );
      return;
    }
    this.expandedStatusService.activedExapandedRow.push(this.expandedElement);
  }
  constructor(
    private readonly elementRef: ElementRef,
    private expandedStatusService: ExpandedStatusService
  ) {}
}
